/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.8.22",
    versionName: "0.2.0-nightly.2025.8.22",
    versionChannel: "nightly",
    buildDate: "2025-08-22T00:07:18.816Z",
    commitHash: "9510d19ca63483b74496f4bb03e37c3f706cb1ea",
};
